// Central media registry.
// Every image/video in the site is declared here with:
//   - publicId  → Cloudinary Public ID (inside root folder). Once uploaded,
//                 assets update automatically without code changes.
//   - fallback  → local file / external URL served if Cloudinary asset is
//                 missing or Cloudinary is not configured.
//
// Folder structure on Cloudinary (Peak-Adventures-Malnad/…):
//   hero/…, about/…, rooms/…, food/…, bonfire/…,
//   guestnote/…, nearby-attractions/…, gallery/…, logo/…, icons/…

export const MEDIA = {
  // Hero
  heroVideo:    { publicId: "hero/drone-view",   fallback: "/hero-drone.mp4" },
  heroPoster:   { publicId: "hero/poster",       fallback: "https://images.unsplash.com/photo-1660294534711-75a9474fecb0?auto=format&fit=crop&w=1600&q=80" },

  // Logo & icons
  logoNav:      { publicId: "logo/nav-logo",     fallback: "/logo.jpg" },
  logoFooter:   { publicId: "logo/footer-logo",  fallback: "/logo-footer.jpg" },
  favicon:      { publicId: "icons/favicon",     fallback: "/favicon.png" },

  // About
  aboutAmbience:{ publicId: "about/ambience",    fallback: "https://customer-assets.emergentagent.com/job_western-ghats-escape/artifacts/rvhz1iu9_2.jpg" },
  aboutEstate:  { publicId: "about/estate",      fallback: "/estate.jpg" },

  // Rooms
  roomCouple:   { publicId: "rooms/couple",      fallback: "/room-couple.jpg" },
  roomFamily:   { publicId: "rooms/family",      fallback: "/room-family.jpg" },
  roomGroup:    { publicId: "rooms/group",       fallback: "/room-group.jpg" },
  roomDorm:     { publicId: "rooms/dormitory",   fallback: "/room-dormitory.jpg" },

  // Food
  diningTable:  { publicId: "food/dining-table", fallback: "https://customer-assets.emergentagent.com/job_western-ghats-escape/artifacts/13ink5ks_6.png" },
  dishNeerDosa: { publicId: "food/neer-dosa",    fallback: "/dish-neerdosa.jpg" },
  dishKadubu:   { publicId: "food/kadubu",       fallback: "/dish-kadubu.jpg" },

  // Bonfire
  campfire:     { publicId: "bonfire/main",      fallback: "https://images.unsplash.com/photo-1478131143081-80f7f84ca84d?auto=format&fit=crop&w=1600&q=80" },
};

// Convenience accessor: `mediaUrl("roomCouple")` → fallback URL (or Cloudinary
// once configured). Kept simple so existing <img src=…> calls keep working.
import { cldImage } from "@/lib/cloudinary";

export function mediaUrl(key, opts) {
  const m = MEDIA[key];
  if (!m) return "";
  return cldImage(m.publicId, opts) || m.fallback;
}
